import * as React from 'react'

import styled from '@theme/styled-components'
import AccentSanitizer from '../../../utils/AccentSanitizer'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'

interface Props {
  companyGroup: CompanyGroup
  searchText: string
  onClick: () => void
  isOpened: boolean
  toggleOpenedState: () => void
}

export const AdminCompaniesGroup = ({ companyGroup, onClick, searchText, isOpened, toggleOpenedState }: Props) => {
  const sanitizer = new AccentSanitizer() // gestion de la casse

  const sanitize = (text: string) => {
    return sanitizer.sanitize(text.trim())
  }

  const renderItem = (company: CompanyGroupCompany, searchText: string) => (
    <CompaniesContainer key={company.id} isOpened={isOpened} onClick={onClick}>
      <CompanyContainer>
        <CompanyLettersNameContainer>
          <LettersName>{company.name.slice(0, 1)}</LettersName>
        </CompanyLettersNameContainer>
        <CompanyInformation>
          <CompanyNames wordSearched={sanitize(company.name).includes(sanitize(searchText))}>
            {company.name}
          </CompanyNames>
        </CompanyInformation>
      </CompanyContainer>
    </CompaniesContainer>
  )
  return (
    <Container>
      <GroupContainer>
        <LeftGroup onClick={onClick}>
          <GroupLettersNameContainer>
            <LettersName>{companyGroup.name.slice(0, 1)}</LettersName>
          </GroupLettersNameContainer>
          <CompanyInformation>
            <CompanyNames wordSearched={sanitize(companyGroup.name).includes(sanitize(searchText))}>
              {companyGroup.name}
            </CompanyNames>
          </CompanyInformation>
        </LeftGroup>
        <RightGroup onClick={toggleOpenedState}>
          {isOpened ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}
        </RightGroup>
      </GroupContainer>
      {companyGroup.companies.map((company: CompanyGroupCompany) => renderItem(company, searchText))}
    </Container>
  )
}

const Container = styled('div')`
  height: 100px;
`
const CompanyContainer = styled('div')`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0px 25px 5px 86px;
`
const GroupContainer = styled('div')`
  height: 100px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0px 25px 0px 25px;
  border: 0px solid #f1f1f1;
  border-bottom-width: 1px;
  border-top-width: 1px;
  justify-content: space-between;
  &: hover {
    background-color: ${(props) => props.theme.colors.filterBackgroundColor};
  }
`
const LeftGroup = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`
const RightGroup = styled('div')``
const CompaniesContainer = styled('div')<{ isOpened: boolean }>`
  height: 100px;
  cursor: pointer;
  display: flex;
  align-items: center;
  &: hover {
    background-color: ${(props) => props.theme.colors.filterBackgroundColor};
  }
  visibility: ${(props) => (props.isOpened ? 'visible' : 'hidden')};
`
const GroupLettersNameContainer = styled('div')`
  background-color: ${(props) => props.theme.colors.primary_blue};
  height: 60px;
  width: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`
const CompanyLettersNameContainer = styled('div')`
  background-color: ${(props) => props.theme.colors.primary_green};
  height: 60px;
  width: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`
const LettersName = styled('div')`
  ${(props) => props.theme.fonts.calendarLibelle};
  color: ${(props) => props.theme.colors.secondary_text};
  text-align: center;
`
const CompanyInformation = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
`
const CompanyNames = styled('div')<{ wordSearched?: boolean }>`
  font-family: Avenir;
  font-style: normal;
  font-size: 17px;
  font-weight: ${(props) => (props.wordSearched ? 900 : 0)};
  color: ${(props) => (props.wordSearched ? props.theme.colors.titleColor : props.theme.colors.disabled)};
`
